import optimizely from 'util/optimizely';
import { Flags } from 'util/optimizely/types';

import { BANNER_HORIZON_URN, BANNER_RISETERM_URN } from '../constants';

export const isBannerRisetermEnabled = () =>
  optimizely.isFeatureEnabled(Flags.BANNER_RISETERM_PRODUCT_ENABLED, 'life-web');

export const getBannerProductUrn = () =>
  isBannerRisetermEnabled() ? BANNER_RISETERM_URN : BANNER_HORIZON_URN;
